import { create } from 'zustand';
import type { Settings } from '../types';

interface AppState {
  settings: Settings | null;
  setSettings: (settings: Settings) => void;
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
  error: string | null;
  setError: (error: string | null) => void;
}

export const useAppStore = create<AppState>((set) => ({
  settings: null,
  setSettings: (settings) => set({ settings }),
  isLoading: false,
  setLoading: (isLoading) => set({ isLoading }),
  error: null,
  setError: (error) => set({ error }),
}));

// Format price helper
export const formatPrice = (price: number | string | null | undefined): string => {
  const num = typeof price === 'string' ? parseFloat(price) : (price ?? 0);
  const safe = Number.isFinite(num as number) ? (num as number) : 0;
  return safe.toLocaleString('uz-UZ').replace(/,/g, ' ');
};

// Format date helper
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('uz-UZ', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
